type Video = {
  video: string
  title?: string
}

export type VideoProps = {
  videos: Video[]
}

const singleTemplateClass = `
  @[0px]/single-simple:!grid-cols-1
  @[600px]/single-simple:!grid-cols-2
`

export default function VideoGrid({ videos }: VideoProps) {
  return (
    <div className="component component--video">
      <div className="container @[0px]/single-simple:!max-w-[var(--container-s-max-w)]">
        <div
          className={`grid items-start gap-x-m gap-y-l m:grid-cols-2 s:grid-cols-1 m-up:grid-cols-3 ${singleTemplateClass}`}>
          {videos.map((video, index: number) => {
            if (!video) return null

            const { video: videoHtml, title } = video

            if (!videoHtml) return null

            return (
              <div key={index} className="video-grid__item flex flex-col gap-m">
                <div
                  className="mx-auto aspect-[16/9] w-full overflow-hidden rounded-md"
                  dangerouslySetInnerHTML={{ __html: videoHtml }}></div>

                {title ? <span className="h4">{title}</span> : null}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
